'use client';

import { useSearchParams } from 'next/navigation';
import { signIn } from 'next-auth/react';
import { useEffect } from 'react';

const COGNITO_IDENTITY_PROVIDER = 'clearchannel-ad';

export const SignInRedirect = () => {
  const searchParams = useSearchParams();

  useEffect(() => {
    const callbackUrl = searchParams.get('callbackUrl') ?? '/';

    signIn('cognito', { callbackUrl }, { ['identity_provider']: COGNITO_IDENTITY_PROVIDER });
  }, [searchParams]);

  return null;
};
